import { styled, Tooltip, tooltipClasses } from "@mui/material"


const CustomTooltip = styled( ( { className, ...props } ) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
) )( ( { theme, ...rest } ) => {
    return ( {

        [`& .${tooltipClasses.arrow}`]: {
            color: rest.bg || "",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: rest.bg || "",
            color: rest.color || "",
            padding: "10px",
            fontStyle: "italic",
            borderRadius: theme.layout.borderRadius,
        },
    } )
} )

export default CustomTooltip